import RewardPromoList from './components/RewardPromoList';
import { bindActionCreators } from 'redux';
import withRouter from 'react-router-dom/withRouter'
import values from 'lodash/values';
import get from 'lodash/get';
import { connect } from 'react-redux';
import moment from 'moment'

import {
    loadRewardPromos,
    createPromo,
    updatePromo,
    deletePromo,
    loadPromoDefaults
} from '../../shared/redux/entities/actions'

function mapStateToProps(state,props){
  return {
     rewardPromos:values(get(state,['entities','promos'],{}))
    // rewardPromos:[
    //     {
    //         id: "3DB36108-0F7F-4DF9-BEFE-ABD3E66F0581",
    //         name: "Survey 2x - New Year",
    //         domain: "survey",
    //         status: "DRAFT",
    //         startDate: moment(),
    //         endDate: moment().add(7, "day")
    //     },
    //     {
    //         id: "3DB36108-0F7F-4DF9-BEFE-ABD3E66F0581",
    //         name: "OW 2x SuperBowl",
    //         domain: "offer",
    //         status: "ACTIVE",
    //         startDate: moment(),
    //         endDate: moment().add(7, "day")
    //     },
    //     {
    //         id: "3DB36108-0F7F-4DF9-BEFE-ABD3E66F0581",
    //         name: "Survey 3x – Week 2 Jan",
    //         domain: "survey",
    //         status: "DRAFT",
    //         startDate: moment(),
    //         endDate: moment().add(7, "day")
    //     },
    // ]
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
      loadRewardPromos,
      createPromo,
      updatePromo,
      deletePromo,
      loadPromoDefaults
  },dispatch);
}

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(RewardPromoList));



// WEBPACK FOOTER //
// ./src/routes/RewardPromoList/index.js